

































import Vue from 'vue';
import { notify } from 'mycorems-app-shared';
import { User } from '../../types';
import { login } from '../../auth';
import AsyncBtn from '../../components/AsyncBtn.vue';
import { acceptInvite } from '.';

interface Data {
  password: string,
  task: Promise<any>|null,
}

export default Vue.extend({
  components: {
    AsyncBtn,
  },
  props: {
    token: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      password: '',
      task: null,
    };
  },
  methods: {
    accept() {
      this.task = acceptInvite(this.token, this.password);
      this.task.then((user: User) => {
        notify.success('Your account has been set up.');
        this.login(user.email);
      });
    },
    login(email: string) {
      this.task = login(email, this.password, false);
      this.task.then(() => {
        this.$router.push('/');
      });
    },
  },
});
